// src/components/modal/index.ts

import Modal from './Modal.tsx';

export default Modal;